import styled from "styled-components/macro";

export const H2 = styled.h2`
  margin-top: 5px;
  margin-bottom: 54px;
`;

export const InputsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Label = styled.div`
  //color: #4c5464;
  font-weight: 400;
  margin-bottom: 3px;
  ${(p) => `color: ${p.labelColor};`}
`;

export const Sup = styled.span`
  // font-size: 12px;
  // line-height: 0;
  // margin-left: -3px;
`;

export const RequiredIcon = () => (
  <RequiredIconStyle className="fas fa-asterisk" />
);

const RequiredIconStyle = styled.span`
  margin-left: 2px;
  transform: scale(0.6);
  opacity: 0.8;
`;
